var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "768px",
    height: "508px",
    viewBox: "0 0 768 508",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sg",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 768 0 768 512 0 512"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEEEE",
    points: "0 256 257.7 205 512 256 512 512 0 512"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D80027",
    points: "0 0 808 0 808 256 0 256"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.4686, 55.6956)",
    fill: "#EEEEEE",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3314384,77.9044493 C34.3639335,41.3256557 59.8111576,9.68294742 95.5314384,1.80444935 C90.0455408,0.606618192 84.446585,0.00313792543 78.8314384,0.00444934961 C48.7497558,-0.315961353 21.1651802,16.6914916 7.94098626,43.7124277 C-5.28320772,70.7333637 -1.78951026,102.950694 16.9195472,126.508738 C35.6286047,150.066783 66.2177121,160.765791 95.5314384,154.004449 C59.8111576,146.125951 34.3639335,114.483243 34.3314384,77.9044493 L34.3314384,77.9044493 Z M134.531438,5.50444935 L140.031438,22.5044493 L158.031438,22.5044493 L143.431438,33.0044493 L149.031438,50.0044493 L134.531438,39.5044493 L120.031438,50.0044493 L125.631438,33.0044493 L111.131438,22.5044493 L129.031438,22.5044493 L134.531438,5.50444935 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1314384,38.9044493 L96.7314384,55.9044493 L114.531438,55.9044493 L100.131438,66.4044493 L105.631438,83.4044493 L91.1314384,72.9044493 L76.7314384,83.4044493 L82.2314384,66.4044493 L67.7314384,55.9044493 L85.6314384,55.9044493 L91.1314384,38.9044493 Z M177.931438,38.9044493 L183.431438,55.9044493 L201.331438,55.9044493 L186.831438,66.4044493 L192.331438,83.4044493 L177.931438,72.9044493 L163.431438,83.4044493 L168.931438,66.4044493 L154.531438,55.9044493 L172.331438,55.9044493 L177.931438,38.9044493 Z M161.231438,89.0044493 L166.731438,106.004449 L184.631438,106.004449 L170.131438,116.504449 L175.631438,133.504449 L161.231438,123.004449 L146.731438,133.504449 L152.231438,116.504449 L137.831438,106.004449 L155.731438,106.004449 L161.231438,89.0044493 Z M107.831438,89.0044493 L113.331438,106.004449 L131.331438,106.004449 L116.831438,116.504449 L122.331438,133.504449 L107.831438,123.004449 L93.4314384,133.504449 L98.9314384,116.504449 L84.4314384,106.004449 L102.331438,106.004449 L107.831438,89.0044493 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.f2effdd30f127b92afd3272b782cd8c2.svg";
export { ForwardRef as ReactComponent };